import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["resolveContext"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import createSagaMiddleware from 'redux-saga';
import { getClient } from '@resolve-js/client';
import rootSaga from './root-saga';

var emptySaga = /*#__PURE__*/_regeneratorRuntime.mark(function emptySaga() {
  return _regeneratorRuntime.wrap(function emptySaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, emptySaga);
});

var wrapSagaMiddleware = function wrapSagaMiddleware(sagaMiddleware) {
  var run = function run(isClient, context) {
    var client = getClient(context.resolveContext);
    var queryIdMap = new Map();

    var resolveContext = context.resolveContext,
        restContext = _objectWithoutPropertiesLoose(context, _excluded);

    var backCompatibleArgs = _extends({}, restContext, resolveContext);

    sagaMiddleware.run(isClient ? rootSaga : emptySaga, _extends({}, backCompatibleArgs, {
      queryIdMap: queryIdMap,
      client: client
    }));
  };

  var middleware = function middleware() {
    return sagaMiddleware.apply(void 0, arguments);
  };

  Object.defineProperty(middleware, 'run', {
    get: function get() {
      return run;
    }
  });
  return middleware;
};

var createResolveMiddleware = function createResolveMiddleware() {
  return wrapSagaMiddleware(createSagaMiddleware());
};

export default createResolveMiddleware;
//# sourceMappingURL=create-resolve-middleware.js.map